export default __webpack_public_path__ + "static/media/Events.f94d170b.svg";